import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import ControlCenter from './control-center'
import ControlVolume from './control-volume'
import ControlPlay from './control-play'
import styles from './control.css'

export const CONTROL_FADE_TIMEOUT = 2000

class ControlStream extends React.PureComponent {
  state = {
    isUserInteracted: false
  }

  componentDidMount() {
    window.addEventListener('touchstart', this.toggleControl)
    window.addEventListener('mousemove', this.toggleControl)
    window.addEventListener('click', this.toggleControl)
  }

  componentWillUnmount() {
    window.removeEventListener('touchstart', this.toggleControl)
    window.removeEventListener('mousemove', this.toggleControl)
    window.removeEventListener('click', this.toggleControl)

    clearTimeout(this.touchTimer)
  }

  toggleControl = () => {
    clearTimeout(this.touchTimer)
    this.setState({ isUserInteracted: true }, () => {
      this.touchTimer = setTimeout(() => {
        this.setState({ isUserInteracted: false })
      }, CONTROL_FADE_TIMEOUT)
    })
  }

  render() {
    const { player } = this.props
    if (!player) return null

    const {
      isPlaying,
      isMuted,
      onMuteChange,
      onInteraction,
      inHighlightedContent
    } = this.props
    const { isUserInteracted } = this.state

    const handleInteraction = (callback) => () => {
      if (onInteraction) {
        onInteraction()
      }
      callback()
    }

    return (
      <div className={styles.wrapper}>
        <ControlCenter
          wrapperClassName={styles.controlPlay}
          play={handleInteraction(() => player.play())}
          pause={handleInteraction(() => player.pause())}
          isPlaying={isPlaying}
        />
        <div
          className={classnames(styles.lowerControlWrapper, {
            [styles.show]: !isPlaying || isUserInteracted,
            [styles.controlBottomOffset]: inHighlightedContent
          })}
        >
          <ControlPlay
            wrapperClassName={styles.controlElement}
            iconWrapperClassName={styles.lowerControlIconWrapper}
            iconClassName={styles.lowerControlIcon}
            play={handleInteraction(() => player.play())}
            pause={handleInteraction(() => player.pause())}
            isPlaying={isPlaying}
          />
          <ControlVolume
            wrapperClassName={styles.controlElement}
            iconClassName={classnames(
              styles.lowerControlIcon,
              styles.lowerControlIconWrapper
            )}
            isMuted={isMuted}
            mute={handleInteraction(() => {
              player.muted(true)
              if (onMuteChange) {
                onMuteChange(true)
              }
            })}
            unmute={handleInteraction(() => {
              player.muted(false)
              if (onMuteChange) {
                onMuteChange(false)
              }
            })}
          />
        </div>
      </div>
    )
  }
}

ControlStream.propTypes = {
  player: PropTypes.shape({
    play: PropTypes.func.isRequired,
    pause: PropTypes.func.isRequired,
    muted: PropTypes.func.isRequired
  }),
  isPlaying: PropTypes.bool.isRequired,
  isMuted: PropTypes.bool,
  onMuteChange: PropTypes.func,
  onInteraction: PropTypes.func,
  inHighlightedContent: PropTypes.bool
}

ControlStream.defaultProps = {
  player: null,
  isMuted: true,
  onMuteChange: undefined,
  onInteraction: undefined,
  inHighlightedContent: false
}

export default ControlStream
